import * as Yup from 'yup';

export const CREATE_SURVEY_VALIDATION_SCHEMA = Yup.object().shape({
  surveyName: Yup.string()
    .max(200, 'Превышено допустимое количество символов')
    .test('no-leading-trailing-spaces', 'Удалите лишние пробелы', (value) => value?.trim() === value)
    .matches(/^(?!.* {2,}).*$/, 'Необходимо использовать только один знак пробела')
    .required('Обязательное поле'),
  isActive: Yup.boolean().required(),
  startDate: Yup.date().required('Обязательное поле'),
  endDate: Yup.date()
    .required('Обязательное поле')
    .min(Yup.ref('startDate'), 'Дата окончания должна быть больше или равна дате начала'),
});
